import { useState } from 'react';

const boxDim = 20;

export default function Structure({ 
  template,
  structure, 
  size=boxDim,
  onClick, 
  interactive, 
  styleByChannel={},
  onChange = () => {},
  placements=[],
  channelId,
}){
  let rows = structure;
  if( !rows.map ){
    debugger;
  }

  const state = Object.fromEntries(placements.map(k => ([k,true])));

  //const [ state, setState ] = useState({});

  return <div>{rows.map(col => (
    <div class="sg-row">
      {col.map((node,ii) => (

        <div 
          onClick={() => {
            let newPlacements;
            let shouldRemove = placements.includes(node);

            let { channelGroups } = template.compact;

            let newChannelGroup;

            if( shouldRemove ){
              newChannelGroup = channelGroups[node].filter(x => x!==channelId)
            }else{
              newChannelGroup = [...(channelGroups[node]||[]),channelId]
            }

            let newChannelGroups = {
              ...template.compact.channelGroups,
              [node]:newChannelGroup
            }

            onChange({
              channelGroups:newChannelGroups,
            });
            //setState({...state,[node]:!Boolean(state[node])})
          }}
          style={{ 
            //zIndex:(col.length - ii),
            position:'relative',
            pointerEvents:(interactive===false?"none":"auto"),
            border:'1px solid black', 
            width:size, 
            height:size,
            background:(state[node] ? "#ccc" : "unset"),
            ...styleByChannel[node],
          }}>
          {interactive===true && <div style={{
            zIndex:10,
          }} class="absolute-cover outline-on-hover"/>}
          
        </div>
      ))}
    </div>
  ))}</div>
}
